<div class="ptop" (window:resize)="onResize($event)">
  <canvas #cCanvas class="canvas"></canvas>
</div>
